import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoData } from '../components/';
import { Dictionary } from '../Dati';
import { CampoJSON } from './CampoJSON';


interface IInputJSONProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: Glob.DatiJSON;

}

export class InputJSON extends BasePureComponent<IInputJSONProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")) {
            etichetta = <label>{this.props.Etichetta}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }

        return <div style={{ minHeight: 200 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <CampoJSON Valore={this.props.Valore} Id={this.props.Id} Name={this.props.Name} OnChange={this.props.OnChange} />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputJSON.tsx